import { Props, Wrapper } from './Editable';
import { useEffect, useState } from 'react';
import Input from '../../../../../atoms/Input';
import EditableMenu from './EditableMenu';
import TextArea from '../../../../EventView/Form/TextArea';

const EditableTextArea: React.FC<Props<string, string>> = ({
  value,
  onSubmit,
}) => {
  const [isEditMode, setEditMode] = useState<boolean>(false);
  const [prompt, setPrompt] = useState<string>(value);

  useEffect(() => {
    setPrompt(value);
  }, [value]);

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setPrompt(event.target.value);
  };

  const handleSubmit = () => {
    setEditMode(false);
    setPrompt(value);
    onSubmit(prompt);
  };

  const handleRollback = () => {
    setEditMode(false);
    setPrompt(value);
  };

  return (
    <Wrapper>
      <TextArea onChange={handleChange} value={prompt} disabled={!isEditMode} />
      <EditableMenu
        isEditing={isEditMode}
        onEdit={() => setEditMode(true)}
        onCancel={handleRollback}
        onSubmit={handleSubmit}
      />
    </Wrapper>
  );
};

export default EditableTextArea;
